// ** Icons Import
import { PieChart, Circle } from 'react-feather'

export default [
  {
    header: 'Charts'
  },
  {
    id: 'charts',
    title: 'Sales',
    badge: 'light-danger',
    badgeText: '3',
    icon: <PieChart size={20} strokeWidth={1} />,
    navLink: '/charts/apex'
  }
]
